export default "__VITE_ASSET__Bz2CNwzX__"